import React from 'react';

import {
    makeStyles,
    Grid,
    Table,
    TableHead,
    TableRow,
    TableCell,
    Button,
    TableBody,
    Box,
    CircularProgress,
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentIcon from '@material-ui/icons/Assignment';
import CheckIcon from '@material-ui/icons/Check';

import styles from './styles';
import notification from '../../config/notification';
const useStyles = makeStyles(styles);

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const TableData = (props) => {
    const classes = useStyles();
    const { tabledata, handlechange, handleblur, blockadd } = props;
    const fieldProps = { ...props };
    const { changeelement, customEditElement, canEdit, loading, isInternalForm, tableLimit } = props.options;
    let canAdd = true;

    if (tableLimit && tabledata?.data && tabledata.data.length === tableLimit) {
        canAdd = false;
    }

    return (
        <Table className={classes.table} aria-label="customized table">
            <TableHead>
                <TableRow className={classes.tableRowAlignMiddle}>
                    {tabledata.columns.map((column, index) => {
                        return (
                            <TableCell key={`headcell-${index}`} className={classes.headTableCell} align={column.align}>
                                {column.title}
                            </TableCell>
                        );
                    })}
                    <TableCell className={classes.headTableCell} align="center">
                        {blockadd && <CircularProgress size={16} style={{ color: '#fff', marginTop: '5px' }} />}
                        {!blockadd && canEdit && canAdd && (
                            <Button
                                variant="contained"
                                color="primary"
                                disableElevation
                                onClick={() => changeelement()}
                                className={classes.addButton}>
                                <AddIcon /> Adicionar
                            </Button>
                        )}
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {loading && (
                    <TableRow className={classes.tableRowAlignMiddle}>
                        <TableCell align={'center'}>
                            <CircularProgress size={16} />
                        </TableCell>
                    </TableRow>
                )}
                {tabledata.data.map((row, indexRow) => (
                    <TableRow key={`row-${indexRow}`} className={classes.tableRow}>
                        {tabledata.columns.map((column, indexColumn) => {
                            const EditComponent = column.editComponent;
                            const showContent = column.showContent;
                            delete fieldProps.addtabledata;
                            delete fieldProps.handlechange;
                            delete fieldProps.canEdit;
                            delete fieldProps.isInternalForm;
                            delete fieldProps.customAddElement;
                            delete fieldProps.customEditElement;
                            return (
                                <TableCell
                                    key={`column-${indexRow}-${indexColumn}`}
                                    align={column.align}
                                    style={{ verticalAlign: 'middle' }}>
                                    {!!EditComponent && (
                                        <>
                                            <EditComponent
                                                {...fieldProps}
                                                name={column.field}
                                                fieldmask={column.fieldmask}
                                                value={row[column.field] ? row[column.field] : ''}
                                                disabled={
                                                    row.canEdit != null ? !row.canEdit : !fieldProps.options?.canEdit
                                                }
                                                checked={row[column.field] ? row[column.field] : false}
                                                onChange={(e) => handlechange(e, indexRow)}
                                                onBlur={(e) => handleblur && handleblur(e, indexRow)}
                                            />
                                        </>
                                    )}
                                    {!!showContent && showContent(row, indexRow)}
                                </TableCell>
                            );
                        })}
                        <TableCell align="right" style={{ verticalAlign: 'middle' }}>
                            {row.isOk && canEdit && (
                                <Button disabled className={classes.btnSigleAction} size="small">
                                    <CheckIcon fontSize="inherit" />
                                </Button>
                            )}
                            {customEditElement && row.showEditButton && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => customEditElement(row, indexRow)}
                                    className={classes.btnSigleAction}
                                    size="small">
                                    {canEdit ? <EditIcon fontSize="inherit" /> : <AssignmentIcon fontSize="inherit" />}
                                </Button>
                            )}

                            {(row.showDeleteButton ||
                                (canEdit && row.canEdit && !isInternalForm && !row.hideDeleteButton)) && (
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => changeelement(indexRow)}
                                    className={classes.btnSigleAction}
                                    disabled={row.canEdit != null ? !row.canEdit : !fieldProps.options?.canEdit}
                                    size="small">
                                    <DeleteIcon fontSize="inherit" />
                                </Button>
                            )}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

function GrowingTable(props) {
    const classes = useStyles();
    const {
        title,
        titleTableLimit,
        tableLimit,
        tabledata,
        addtabledata,
        canEdit,
        isInternalForm,
        customAddElement,
        customEditElement,
        loading,
    } = props;

    const changeelement = (index) => {
        if (index === undefined) {
            if (tabledata?.data?.length === tableLimit) {
                notification('Número máximo de elementos atingido', {
                    toastId: 'MAX_REACHED',
                    type: 'warning',
                });
                return;
            }
        }
        if (customAddElement) customAddElement(index);
        else {
            const temp = [...tabledata.data];
            if (index === undefined) {
                temp.push({});
            } else {
                if (window.confirm('Deseja excluir este item?')) {
                    temp.splice(index, 1);
                }
            }
            addtabledata({ ...tabledata, data: temp });
        }
    };

    return (
        <Grid container>
            <Grid item xs={6}>
                <h3 className={classes.title}>{title}</h3>
            </Grid>
            <Grid item xs={6} style={{ display: 'flex', alignItems: 'center', justifyContent: 'right' }}>
                {!!titleTableLimit && !!tableLimit && (
                    <span>
                        * {titleTableLimit}
                        {tableLimit}
                    </span>
                )}
            </Grid>
            <Grid item xs={12} className={classes.containerTable}>
                <TabPanel>
                    <TableData
                        {...props}
                        options={{
                            tabledata: tabledata,
                            changeelement: changeelement,
                            customEditElement: customEditElement,
                            canEdit: canEdit,
                            loading: loading,
                            isInternalForm: isInternalForm,
                            tableLimit: tableLimit,
                        }}
                    />
                </TabPanel>
            </Grid>
        </Grid>
    );
}

export default GrowingTable;
